﻿import $ from "jquery";
import FiconFactory from "./FiconFactory";

export default function (options) {
	const $iconContainer = $(`#${options.ficonId}`);

	if (ccs_util.isMobile()) {
		options.mode = "lightbox";
	}

	var factory = new FiconFactory(options);

	$iconContainer.on(
		factory.event,
		".ccs-cc-ficons-item",
		function (e) {
			const $icon = $(this);
			var ficon = $icon.data("ficon");

			if (!ficon) {
				ficon = factory.create($icon, options, e);
				$icon.data("ficon", ficon);
			}

			ficon.open(e);
		});
}
